import type { Training } from './vuex';
import type { Training as StudentTraining, TrainingFilter } from '@/views/LMS/Users/Show/Trainings/index.d';

export default {
  training: null as null | Training,
  trainings: [] as StudentTraining[],
  filter: 'showAll' as TrainingFilter,
  searchString: '',
};
